import { useState, useEffect, useRef, useMemo, useCallback } from "react"
import Header from "../../components/Header"
import SearchTimeline from "../../components/timeline/SearchTimeline"
import { hideAlertAction } from "../../actions/alertActions"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { AppBar, ButtonGroup, useTheme } from "@material-ui/core"
import ChartTimeline from "../../components/timeline/Chart"
import CloseIcon from "@material-ui/icons/Close"

//Redux actions
import { requestSavedBuildConcepts } from "../../actions/buildconceptActions"
import { updateTimelineHighlight, updateTimelineSavedTags, updateTimelineSavedTagsExclude } from "../../actions/highlightActions"
import axios from "axios"
import { sourceHelper } from "../../helpers/sourceHelper"
import { requestSources } from "../../actions/sourcesActions"
import { requestCustomTags } from "../../actions/customTagsActions"
import { saveInitSearchSagas } from "../../actions/savedSearchActions"
import WithDrawer from "../../components/common/drawer/withDrawer"
import Notification from "../../components/Notification/Notification"
import { Chip, Box, Button, CircularProgress, Grid, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { ListView } from "./ListView"
import {
	checkNameAlreadyExistFailed,
	getGraphDataRequest,
	getGraphDataRequestClear,
	getTimeLineSearchData,
	getTimeLineSearchDataClear,
} from "../../actions/createTimelineActions"
import {
	GRAPH_DATE_OPTIONS,
	PAYLOAD_DATE_FORMAT,
	ROUTES,
	getQueryParams,
	parsePayload,
	removeFileIdFromLocalStorage,
	useFilters,
	usePrevious,
} from "../../utils"
import { timelineSearchItemsClear } from "../../actions/currentSearchActions"
import { getRetainFiltersList, getRetainFiltersSuccess } from "../../actions/infoActions"
import moment from "moment"
import TimelineGraph from "../../components/timeline/TimelineGraph"
import TimelineChart from "./TimelineChart"
import SavedSearchDateRange from "../../components/timeline/SavedSearchDateRange"
import { setSelectedSearch } from "../../actions/searchActions"
import { showDuplicateAction, showDuplicateActionReset } from "../../actions/filterActions"
import { useTranslation } from "react-i18next"
import { ReviewDropdown } from "../../components/Reviews"
import { getReviewRequest, reSetReview, setIsCaseAdmin, setReview, setReviewRestrictIds } from "../../actions/reviewActions"
import { getEventsRequest, setEventFormOpen, setSelectedEvent, setSelectedEvents } from "../../actions/eventActions"

import EventNoteIcon from "@material-ui/icons/EventNote"
import TimelineIcon from "@material-ui/icons/Timeline"
import ExportIcon from "@material-ui/icons/PictureAsPdf"

import PropTypes from "prop-types"
import Tabs from "@material-ui/core/Tabs"
import Tab from "@material-ui/core/Tab"
import Events from "../../components/timeline/Events"
import { updateTaggedDateReset } from "../../actions/taggedDateActions"
import CreateEvent from "../../components/event/CreateEvent"
import { ModalPopup } from "../../components/modal"
import ExportSVG from "../../components/icons/ExportSVG"
import ExportEvent from "../../components/event/ExportEvent"
import SaveDateRangeDialog from "../../components/common/dialog/SaveDateRangeDialog"
import FileDeleteModal from "../../components/common/FileDeleteModal"
import { reloadList, setIsFileDeleted } from "../../actions/deleteActions"

function TabPanel(props) {
	const { children, value, index, ...other } = props

	return (
		<div role="tabpanel" hidden={value !== index} id={`wrapped-tabpanel-${index}`} aria-labelledby={`wrapped-tab-${index}`} {...other}>
			{value === index && (
				<Box p={1}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	)
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
}

function a11yProps(index) {
	return {
		id: `wrapped-tab-${index}`,
		"aria-controls": `wrapped-tabpanel-${index}`,
	}
}

const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: "transparent",
		},
		"&:hover .MuiOutlinedInput-notchedOutline": {
			borderColor: "transparent",
		},
		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
			borderColor: "transparent",
		},
	},
	notification: {
		padding: theme.spacing(2, 10),
	},
	title: {
		...theme.typography.h5,
	},
	selectedReview: {},
	reviewChip: {
		background: "transparent",
		fontSize: 16,
		fontWeight: 500,
	},
	reviewChipClose: {
		width: 18,
		height: 18,
	},
	graphWrapper: {
		minHeight: 630,
		display: "flex",
	},
	tabs: {
		"& .MuiTab-root": {
			textTransform: "capitalize",
		},
	},
	button: {
		margin: theme.spacing(1),
		color: theme.palette.grey["D300"],
		textTransform: "capitalize",
		fontWeight: 500,
	},
	fileDeletedModal: {
		width: 400,
	},
	btnRefresh: {
		textTransform: "initial",
	},
}))

const PageTimeline = () => {
	/* ******************* REDUX STORE ******************* */
	const dispatch = useDispatch()
	const history = useHistory()
	const theme = useTheme()
	const [t] = useTranslation("global")
	//Access store state
	const classes = useStyles()
	const cargando = useSelector((state) => state.timeline.loading)
	const alert = useSelector((state) => state.alert.alert)
	const isUserLogedInt = useSelector((state) => state.authtentication.loggedIn)
	const currentSearchFilter = useSelector((state) => state.timeline.sourceFilter)
	const highlightFilter = useSelector((state) => state.highlightFilter.timeline)
	const tags = useSelector((state) => state.highlightFilter.timelineTags)
	const tagsExclude = useSelector((state) => state.highlightFilter.timelineTagsExclude)
	const sourceApi = useSelector((state) => state.sources.docs_sources)
	const tagsApi = useSelector((state) => state.tags.custom_tags)
	const selectedBaseId = useSelector((state) => state.multiBase.selectedBase.project_id)
	const globalStateSearchDocumentList = useSelector((state) => state.timeline.timelineResults)
	const savedConceptList = useSelector((state) => state.buildconcept.user_saved_build_concepts)
	const retainedFilterJobData = useSelector((state) => state.info?.retainedFilterJobData)
	const users = useSelector((state) => state.info?.usersList)
	const graphLoading = useSelector((state) => state.timeline?.graphLoading)
	const graphData = useSelector((state) => state.timeline.graph)
	const { isApplyTagSuccess } = useSelector((state) => state.search)
	const { savedSearchs } = useSelector((state) => state.savedSearch)
	const { showDuplicate } = useSelector((state) => state.filter)
	const dateRange = useSelector((state) => state.filter?.dateRange)
	const selectedReview = useSelector((state) => state.review?.review)
	const is_case_admin = useSelector((state) => state?.review?.is_case_admin)
	const isTaggedDateUpdated = useSelector((state) => state.taggedDateReducers?.isTaggedDateUpdated)
	const selectedReviewIds = useSelector((state) => state.review?.restrictIds)
	const reviewList = useSelector((state) => state.review?.list)
	const subjectFilterData = useSelector((state) => state.filter?.subject)
	const openEventForm = useSelector((state) => state.events?.openEventForm)
	const editEvent = useSelector((state) => state.events.event)
	const isFileDeleted = useSelector((state) => state.deleteFile.isFileDeleted)
	const shouldReloadList = useSelector((state) => state.deleteFile.shouldReloadList)
	/* ******************* END REDUX STORE ******************* */

	/* ******************* REACT STATES ******************* */
	const [lastSearchText, setLastSearchText] = useState("")
	const [lastCategories, setLastCategories] = useState([])
	const [graphTagedDate, setGraphTagedDate] = useState({})
	// Filter for elements list
	const [elementsFilter, saveElementsFilter] = useState({
		coloursFilter: "",
		date: "",
	})
	const [filterList, setFilterList] = useState(sourceHelper.getFilter(sourceApi))
	const [tagsList, setTagsList] = useState(tagsApi)

	const [updateFileTypes, setUpdateFiletypes] = useState()
	const [lastFilterList, setLastFilterList] = useState(sourceHelper.getFilter(sourceApi))

	const [requestNewDateSearch, setRequestNewDateSearch] = useState(false)

	// Filters Button
	const [filtersButton, setFiltersButton] = useState(highlightFilter)
	// LINE CHART CONFIG
	const [dataLineChart, setDataLineChart] = useState([])

	const [dateStart, setDateStart] = useState()
	const [dateInput, setDateInput] = useState()
	const [infoPage, setInfoPage] = useState(true)
	const [filterDate, setFilterDate] = useState()
	const [documentsList, setDocumentslist] = useState()
	const [datepicker, setDatepicker] = useState({
		startDate: "",
		endDate: "",
		invalidMessage: "",
	})
	const [changingDateFrom, setChangingDateFrom] = useState("")
	const [dateRangeTotal, setDateRangeTotal] = useState({
		start: "",
		end: "",
	})
	const [border, setBorder] = useState(false)
	const [savedTags, setSavedTags] = useState(tags)
	const [savedTagsExclude, setSavedTagsExclude] = useState(tagsExclude)
	const [tempSearchText, setTempSearchText] = useState(null)
	const [tempCategories, setTempCategories] = useState(null)
	const [requestByFilters, setRequestByFilters] = useState(false)
	const [cancelRequestToken, setCancelRequestToken] = useState({ old: null, new: axios.CancelToken.source() })
	const [fileTypesRefresh, setFileTypesRefresh] = useState(0)
	const [docCount, setDocCount] = useState(0)
	const [isAllDocsViewSelected, setAllDocsView] = useState(true)
	const initilaselectedDateRange = {
		initial: { start: "", end: "" },
		sliderPicker: { start: "", end: "" },
		graphPicker: { start: "", end: "" },
		selected: null,
	}
	const [selectedGraphDateRange, setSelectedGraphDateRange] = useState(initilaselectedDateRange)

	//pagination
	const [page, setPage] = useState(1)
	const [recordsPerPage, setRecordsPerPage] = useState(10)
	const prevRecordsPerPage = usePrevious(recordsPerPage)

	const [sortModel, setSortModel] = useState([])
	const [openSaveDialog, setOpenSaveDialog] = useState(false)

	const GRAPH_PAGE_COUNT = 50000
	const GRAPH_SKIP_COUNT = 0

	/****************Ragnar Lodbrok****************/
	const [canApplyFilter, setCanApplyFilter] = useState(false)
	const [isTimelineSearchEnable, setTimelineSearchCall] = useState(false)
	const [toRetainFilters, setToRetainFilters] = useState(true)

	const [clearAll, setClearAll] = useState(false)
	const [isClearClick, setIsClearClick] = useState(false)

	//event and save date range panel
	const [panel, setPanel] = useState("one")

	const handlePanelChange = (event, currentPanel) => {
		setPanel((prev) => currentPanel)
	}

	const [openExportEvent, setOpenExportEvent] = useState(false)

	/* ******************* END REACT STATES ******************* */
	const timelineSearchCallCount = useRef(0)
	/* ******************* USE-EFFECTS ******************* */
	useEffect(() => {
		dispatch(updateTimelineSavedTagsExclude(savedTagsExclude))
	}, [savedTagsExclude])

	useEffect(() => {
		dispatch(updateTimelineSavedTags(savedTags))
	}, [savedTags])

	useEffect(() => {
		dispatch(updateTimelineHighlight(filtersButton))
	}, [filtersButton])

	useEffect(() => {
		//Render on init
		// dispatch(getSavedBuildConceptsOnAPI());
		// dispatch(requestSources())
		// if (!tagsApi.tags.length) dispatch(requestCustomTags())
		// dispatch(requestSavedBuildConcepts())
		// dispatch(saveInitSearchSagas())
		handleReset()
		// eslint-disable-next-line
		return () => {
			dispatch(getTimeLineSearchDataClear())
			dispatch(timelineSearchItemsClear())
		}
	}, [])

	useEffect(() => {
		dispatch(requestSavedBuildConcepts())
		dispatch(saveInitSearchSagas())
		dispatch(getEventsRequest())
		// setTimeout(() => {
		// 	dispatch(getEventsRequest())
		// }, 1000 * 30)
	}, [selectedBaseId])

	useEffect(() => {
		try {
			if (filtersButton.refreshData === false) {
				return
			}
		} catch (e) {}

		if (tempSearchText !== null || tempCategories !== null) {
			setRequestByFilters(true)
		}
	}, [requestNewDateSearch, filtersButton.fromDate, filtersButton.toDate])

	useEffect(() => {
		if (requestByFilters) {
			setRequestByFilters(false)
			submitSearch(tempSearchText, tempCategories)
		}
		return () => {
			if (cancelRequestToken.old !== null) {
				cancelRequestToken.old.cancel("axios request cancelled")
			}
			dispatch(getGraphDataRequestClear())
		}
	}, [requestByFilters])

	useEffect(() => {
		//regenerateData();
		regenerateData_test()
	}, [])

	// Add border class to input
	useEffect(() => {
		if (alert !== null) {
			setBorder(true)
		} else {
			setBorder(false)
		}
	}, [alert])
	useEffect(() => {
		// if (Object.keys(sourceApi).length === 0 && Object.keys(lastFilterList).length === 0) {
		// 	dispatch(requestSources())
		// 	dispatch(requestCustomTags())
		// }

		if (Object.keys(sourceApi).length > 0) {
			setFilterList(sourceHelper.getFilter(sourceApi))
			setLastFilterList(sourceHelper.getFilter(sourceApi))
		}
	}, [sourceApi])

	useEffect(() => {
		if (toRetainFilters) {
			return
		}
		if (!!sortModel.length) {
			const sort = { field: sortModel[0].field, ordering: sortModel[0].sort === "asc" ? 1 : -1 }
			const skipCount = page === 1 ? 0 : (page - 1) * recordsPerPage
			const refetchGraph = false //will use this flag to check pageNumber change

			let filterWithGraphDate
			if (graphTagedDate?.start && graphTagedDate?.end) {
				filterWithGraphDate = {
					...filters,
					tagged_date: {
						...filters.tagged_date,
						data: [
							moment(graphTagedDate?.start).format(PAYLOAD_DATE_FORMAT),
							moment(graphTagedDate?.end).format(PAYLOAD_DATE_FORMAT),
						],
					},
				}
			} else {
				filterWithGraphDate = filters
			}

			submitSearch(
				tempSearchText,
				tempCategories,
				recordsPerPage,
				skipCount,
				sort,
				parsePayload(filterWithGraphDate),
				refetchGraph,
				selectedGraphDateRange
			)
		}
	}, [sortModel])

	useEffect(() => {
		ref.current = fetchData
	}, [page, sortModel, recordsPerPage, history?.location])

	useEffect(() => {
		if (toRetainFilters) {
			return
		}
		//isApplyTagSuccess && debouncedCallback()
		if (isApplyTagSuccess) {
			const skipCount = page === 1 ? 0 : (page - 1) * recordsPerPage
			const refetchGraph = false //will use this flag to check pageNumber change

			let filterWithGraphDate
			if (graphTagedDate?.start && graphTagedDate?.end) {
				filterWithGraphDate = {
					...filters,
					tagged_date: {
						...filters.tagged_date,
						data: [
							moment(graphTagedDate?.start).format(PAYLOAD_DATE_FORMAT),
							moment(graphTagedDate?.end).format(PAYLOAD_DATE_FORMAT),
						],
					},
				}
			} else {
				filterWithGraphDate = filters
			}

			submitSearch(
				tempSearchText,
				tempCategories,
				recordsPerPage,
				skipCount,
				{},
				parsePayload(filterWithGraphDate),
				refetchGraph,
				selectedGraphDateRange
			)
		}
	}, [isApplyTagSuccess])

	useEffect(() => {
		if (toRetainFilters) {
			return
		}
		debouncedCallback()
	}, [showDuplicate])

	useEffect(() => {
		if (toRetainFilters) {
			return
		}
		isTaggedDateUpdated && debouncedCallback()
	}, [isTaggedDateUpdated])

	useEffect(() => {
		// if (toRetainFilters) {
		// 	return
		// }
		setPage((prevData) => 1)
		debouncedCallback()
	}, [subjectFilterData])

	//reload the list once delete is success then update the flag
	useEffect(() => {
		if (shouldReloadList) {
			dispatch(reloadList(false))
			//debouncedCallback()
			const queryParams = getQueryParams()
			mapDataToState(queryParams)
		}
	}, [shouldReloadList])

	/* ******************* END USE-EFFECTS ******************* */
	const fetchData = () => {
		if (isTimelineSearchEnable) {
			const skipCount = page === 1 ? 0 : (page - 1) * recordsPerPage
			let sort = {}
			if (!!sortModel.length) {
				sort = { field: sortModel[0].field, ordering: sortModel[0].sort === "asc" ? 1 : -1 }
			}
			submitSearch(tempSearchText, tempCategories, recordsPerPage, skipCount, sort, parsePayload(filters))
		}
	}
	const ref = useRef(fetchData)

	const debouncedCallback = useMemo(() => {
		const func = () => {
			ref?.current?.()
		}
		return _.debounce(func, 500)
	}, [])

	const {
		filtersDom,
		filters,
		isEmailFilter,
		handleReset,
		setFilters,
		fromHandler,
		toHandler,
		dateRangeHandler,
		fileTypesHandler,
		tagsHandler,
		commentsByHandler,
		viewHandler,
		setIsEmailFilter,
		handleDateRangeChange,
		subjectSearchHandler,
		initialFilters,
		attachmentHandler,
	} = useFilters({
		setPage,
		ref,
		fetchData,
		debouncedCallback,
		sortModel,
		setSortModel,
		toRetainFilters,
	})

	const mapDataToState = (data) => {
		if (data?.additional_params?.review_id) {
			//dispatch(setReviewRestrictIds(data?.restrict_file_ids))
			//dispatch(getReviewRequest({ id: data?.additional_params?.review_id, is_case_admin: data?.additional_params?.is_case_admin }))
			//setAllDocsView((prev) => false)
			if (!selectedReview?.id && !selectedReview?.name) {
				dispatch(setIsCaseAdmin(data?.additional_params?.is_case_admin))
				dispatch(setReview({ id: data?.additional_params?.review_id }))
			}
		}

		const filterData = mapFiltersToState(data) || {}
		if (data?.sort) setSortModel((prevData) => [{ ...data?.sort, sort: data?.sort?.ordering === 1 ? "asc" : "desc" }])

		let categories = []
		if (data?.categories?.length > 0) {
			categories = savedConceptList?.filter((item) => data?.categories?.includes(item?.id))
		}

		if (data?.additional_params?.search_id?.length > 0 && !_.isEmpty(savedSearchs)) {
			const selectedItem = savedSearchs?.filter((item) => item?.id === data?.additional_params?.search_id)
			if (selectedItem?.length > 0) {
				let selectedSearch = selectedItem?.[0]
				dispatch(setSelectedSearch(selectedSearch))
			}
		}

		if (_.has(data, "remove_duplicates")) {
			dispatch(showDuplicateAction({ data: data?.remove_duplicates }))
		}

		setRecordsPerPage((prevData) => data?.return_count)
		setPage((prevData) => (data?.skip_count === 0 ? 1 : data?.skip_count / data?.return_count + 1))
		setTimelineSearchCall((prevData) => true)
		submitSearch(
			data?.text?.length > 0 ? data?.text?.join(" ") : "",
			categories,
			data?.return_count,
			data?.skip_count,
			data?.sort,
			filterData
		)
	}

	const mapFiltersToState = (data) => {
		const filterKeysAndMethods = {
			from: () => {
				fromHandler(data?.from?.data || [])
			},
			to: () => {
				toHandler(data?.to?.data || [])
			},
			tagged_date: () => {
				dateRangeHandler({
					startDate: data?.tagged_date?.data?.[0] ? moment(data?.tagged_date?.data?.[0]) : "",
					endDate: data?.tagged_date?.data?.[1] ? moment(data?.tagged_date?.data?.[1]) : "",
				})
			},
			source: () => {
				fileTypesHandler(data?.source?.data || [])
				setIsEmailFilter((prevData) => data?.source?.data?.[0] === "email" && data?.source?.data?.length === 1)
			},
			tags: () => {
				tagsHandler(data?.tags?.data || [])
			},
			commentator: () => {
				const names = users?.reduce((allUsers, currUser) => {
					if (data?.commentator?.data?.includes(currUser?.user_id)) {
						const tempUsers = [...allUsers, currUser?.username]
						return tempUsers
					}
					return allUsers
				}, [])
				commentsByHandler(names || [])
			},
			view_count: () => {
				viewHandler(data?.view_count?.kind)
			},
			subject: () => {
				subjectSearchHandler(data?.subject)
			},
			has_attachment: () => {
				attachmentHandler(data?.has_attachment)
			},
		}
		const filterData = {}
		const cloneFilter = _.cloneDeep(initialFilters)
		for (let filterKey of Object.keys(filterKeysAndMethods)) {
			if (data?.[filterKey]) {
				filterData[filterKey] = data?.[filterKey]
			} else {
				filterData[filterKey] = cloneFilter[filterKey]
			}
			filterKeysAndMethods?.[filterKey]?.()
		}

		setFilters((prevData) => ({ ...prevData, ...filterData }))
		return filterData
	}

	useEffect(() => {
		const queryParams = getQueryParams()
		if (
			!_.isEmpty(queryParams) &&
			(!queryParams?.additional_params?.search_id || (savedSearchs?.length > 0 && queryParams?.additional_params?.search_id)) &&
			(queryParams?.categories?.length === 0 || (savedConceptList?.length > 0 && queryParams?.categories?.length > 0))
		) {
			mapDataToState(queryParams)
		}
	}, [retainedFilterJobData, savedConceptList])

	useEffect(() => {
		if (!toRetainFilters) {
			dispatch(getRetainFiltersSuccess())
		}
	}, [toRetainFilters])

	useEffect(() => {
		const queryParams = getQueryParams()
		if (!_.isEmpty(queryParams)) {
			if (queryParams?.categories?.length > 0 || queryParams?.additional_params?.search_id) {
				return
			}
			mapDataToState(queryParams)
		} else {
			setToRetainFilters((prevState) => false)
		}

		// if (history?.location?.pathname?.split("/")?.[2]) {
		// 	setInfoPage((prevData) => false)
		// 	dispatch(getRetainFiltersList(history?.location?.pathname?.split("/")?.[2]))
		// } else {
		// 	setToRetainFilters((prevState) => false)
		// }
		return () => {
			dispatch(getRetainFiltersSuccess())
		}
	}, [])

	useEffect(() => {
		dispatch(showDuplicateActionReset())
	}, [])

	useEffect(() => {
		dispatch(updateTaggedDateReset())
	}, [isTaggedDateUpdated])

	useEffect(() => {
		if (!_.isEmpty(dateRange)) {
			setGraphTagedDate({})
		}
	}, [dateRange])

	useEffect(() => {
		if (globalStateSearchDocumentList?.data?.length > 0) {
			setTimelineSearchCall((prevData) => true)
		}
	}, [globalStateSearchDocumentList])

	useEffect(() => {
		const queryParams = getQueryParams()
		if (reviewList?.length && queryParams?.additional_params?.review_id && !selectedReview?.name) {
			/**
			 * Have a review list
			 * Have the review_id in the query string url
			 * But in selectedreview if we dont have that review name
			 * then we need to set the review as selected
			 * Here we removed getReviewRequest API dependency
			 */
			const id = queryParams?.additional_params?.review_id
			const isCaseAdmin = queryParams?.additional_params?.is_case_admin || false
			const review = reviewList?.find((review) => review?.id === id)
			if (review) {
				dispatch(setIsCaseAdmin(isCaseAdmin))
				dispatch(setReview(review))
			}
		}
	}, [reviewList])

	/* ******************* CUSTOM FUNCTIONS ******************* */
	//Submit Search
	const submitSearch = (
		searchText,
		categories,
		pageSize = 10,
		skipCount = 0,
		sort = {},
		filters = {},
		refetchGraph = true,
		graphdDateRange = selectedGraphDateRange
	) => {
		if (_.isEmpty(sort)) {
			if (sortModel[0]?.field && sortModel[0]?.sort) {
				sort = { field: sortModel[0]?.field, ordering: sortModel[0]?.sort === "asc" ? 1 : -1 }
			} else {
				sort = {}
			}
		}
		setTimelineSearchCall(true)
		let location = "timeline"
		setTempSearchText(searchText)
		setTempCategories(categories)
		setLastSearchText(searchText)
		setLastCategories(categories)

		const conceptsIds = categories?.map((category) => category.id)
		const params = history?.location?.pathname?.split("/")

		//Hide alert
		dispatch(hideAlertAction())
		//Send to API
		//Get date filter
		let searchFilters = { ...filterList, datesFilter: { fromData: filtersButton.fromDate, toDate: filtersButton.toDate } }

		if (!_.isEmpty(graphdDateRange) && graphdDateRange?.selected) {
			const filterDateRange = graphdDateRange[graphdDateRange.selected]
			filters = {
				...filters,
				tagged_date: {
					...filters.tagged_date,
					kind: 211,
					data: [
						moment(filterDateRange?.start).format(PAYLOAD_DATE_FORMAT),
						moment(filterDateRange?.end).format(PAYLOAD_DATE_FORMAT),
					],
				},
			}
		}

		let restrict_file_ids = []
		// if (selectedReviewIds?.length > 0) {
		// 	restrict_file_ids = [...selectedReviewIds]
		// }

		setCancelRequestToken({ old: cancelRequestToken.new, new: axios.CancelToken.source() })
		dispatch(
			getTimeLineSearchData(
				searchText,
				filtersObject,
				conceptsIds,
				cancelRequestToken.new,
				pageSize,
				skipCount,
				sort,
				filters,
				params?.[1],
				false,
				toRetainFilters ? history?.location?.pathname?.split("/")?.[2] : null,
				graphdDateRange,
				restrict_file_ids,
				selectedReview?.id,
				is_case_admin
			)
		)
		if (refetchGraph) {
			//for BA-168 testing purpose setTimeout removed
			dispatch(
				getGraphDataRequest(
					searchText,
					filtersObject,
					conceptsIds,
					cancelRequestToken.new,
					GRAPH_PAGE_COUNT,
					GRAPH_SKIP_COUNT,
					sort,
					filters,
					"",
					true,
					null,
					{},
					restrict_file_ids,
					selectedReview?.id,
					is_case_admin
				)
			)
		}
		setToRetainFilters((prevData) => false)
	}

	const getSkipCount = () => {
		return page === 1 ? 0 : (page - 1) * recordsPerPage
	}

	const regenerateData = () => {
		const chartData = []
		for (let i = 0; i < 20; i++) {
			const value = Math.floor(Math.random() * i + 3)
			chartData.push({
				label: i,
				value,
				tooltipContent: { startDate: i, endDate: value },
			})
		}
		setDataLineChart(chartData)
	}
	const regenerateData_test = () => {
		const chartData_test = [
			{
				label: "Feb",
				value: 10,
				//tooltipContent: {startDate: 'Jan', endDate: 10}
			},
			{
				label: "March",
				value: 20,
				//tooltipContent: {startDate: 1, endDate: 20}
			},
			{
				label: "April",
				value: 30,
				//tooltipContent: {startDate: 2, endDate: 30}
			},
			{
				label: "May",
				value: 20,
				//tooltipContent: {startDate: 3, endDate: 20}
			},
		]

		setDataLineChart(chartData_test)
	}

	/* ******************* END CUSTOM FUNCTIONS ******************* */

	/* ******************* VARIABLES ******************* */
	const filtersObject = { ...filtersButton, ...filterList }
	let checker = (arr, target) => target.every((v) => arr.includes(v))
	/* ******************* END VARIABLES ******************* */
	try {
		document.body.style.backgroundImage = "none"
		document.body.classList.remove("newLoginPage")
	} catch (e) {}

	const updateGraphDateRange = (date) => {
		const updatedDate =
			date.selected === GRAPH_DATE_OPTIONS.SLIDER
				? {
						...initilaselectedDateRange,
						selected: date.selected,
						sliderPicker: date[GRAPH_DATE_OPTIONS.SLIDER],
				  }
				: { ...selectedGraphDateRange, selected: date.selected, graphPicker: date[GRAPH_DATE_OPTIONS.GRAPH_PICKER] }

		setSelectedGraphDateRange((prev) => updatedDate)
		setGraphTagedDate(
			date.selected === GRAPH_DATE_OPTIONS.SLIDER ? date[GRAPH_DATE_OPTIONS.SLIDER] : date[GRAPH_DATE_OPTIONS.GRAPH_PICKER]
		)
	}

	/*
		debounceSubmitSearchGraphDate: For debounce effect configured here
		submitSearch: call a fun after 1000ms 
		refetchGraph: flase means only List API will called
	*/
	const DEBOUNCE_TIME = 2000
	const debounceSubmitSearchGraphDate = _.debounce(submitSearch, DEBOUNCE_TIME)
	const debounceGraphDateRange = _.debounce(updateGraphDateRange, DEBOUNCE_TIME)
	const refetchList = useCallback(
		(date) => {
			const skipCount = page === 1 ? 0 : (page - 1) * recordsPerPage

			const filterWithGraphDate = {
				...filters,
				tagged_date: {
					...filters.tagged_date,
					//data: [moment(date?.start).format(PAYLOAD_DATE_FORMAT), moment(date?.end).format(PAYLOAD_DATE_FORMAT)],
					data:
						date.selected === GRAPH_DATE_OPTIONS.SLIDER
							? [
									moment(date[GRAPH_DATE_OPTIONS.SLIDER]?.start).format(PAYLOAD_DATE_FORMAT),
									moment(date[GRAPH_DATE_OPTIONS.SLIDER]?.end).format(PAYLOAD_DATE_FORMAT),
							  ]
							: [
									moment(date[GRAPH_DATE_OPTIONS.GRAPH_PICKER]?.start).format(PAYLOAD_DATE_FORMAT),
									moment(date[GRAPH_DATE_OPTIONS.GRAPH_PICKER]?.end).format(PAYLOAD_DATE_FORMAT),
							  ],
				},
			}

			const refetchGraph = false
			debounceGraphDateRange(date)
			debounceSubmitSearchGraphDate(
				tempSearchText,
				tempCategories,
				recordsPerPage,
				skipCount,
				sortModel,
				parsePayload(filterWithGraphDate),
				refetchGraph,
				date
			)
			// if (graphDateType === "sliderPicker") {
			// 	debounceGraphDateRange(date)
			// } else {
			// 	debounceGraphDateRange(date)
			// }
		},
		[tempSearchText, tempCategories, filters]
	)

	const handleRemoveReviewContext = () => {
		if (selectedReview?.id) {
			//if we are in context of review remove review context
			history.push(ROUTES.TIMELINE) //remove query string
			setClearAll((prev) => true)
			dispatch(reSetReview())
		}
	}

	useEffect(() => {
		if (Object.keys(selectedReview)?.length > 0) {
			//clear all fields
			//setClearAll((prev) => true)
			//call search function
			//submitSearch("", [])
			const skipCount = page === 1 ? 0 : (page - 1) * recordsPerPage
			let sort = {}
			if (!!sortModel.length) {
				sort = { field: sortModel[0].field, ordering: sortModel[0].sort === "asc" ? 1 : -1 }
			}
			submitSearch(tempSearchText || "", tempCategories || [], recordsPerPage, skipCount, sort, parsePayload(filters))
		}
	}, [selectedReview])

	useEffect(() => {
		if (isClearClick && Object.keys(selectedReview)?.length > 0) {
			setIsClearClick((prev) => false)
			submitSearch("", [])
		}
	}, [isClearClick])

	//unmount the component
	useEffect(() => {
		return () => {
			dispatch(reSetReview())
			//dispatch(setSelectedEvents([]))
		}
	}, [])

	useEffect(() => {
		window.addEventListener("beforeunload", removeFileIdFromLocalStorage)

		return () => {
			window.removeEventListener("beforeunload", removeFileIdFromLocalStorage)
			removeFileIdFromLocalStorage()
		}
	}, [])

	const reviewSelectedCallback = () => {
		setTempSearchText("")
		setTempCategories([])
		setClearAll(true)
	}

	const handleOpenSaveEventDialog = (reLoadList = false) => {
		if (reLoadList) {
			//if status true -> event successfuly saved -> refresh the events list
			dispatch(getEventsRequest())
		}
		handleEventForm(false)
	}

	const handleEventForm = (isOpen) => {
		dispatch(setEventFormOpen(isOpen))
	}

	return (
		<Grid className={classes.root} container direction="row" data-testid="create_timeline_page">
			<Grid item xs={12} className={classes.notification}>
				<Notification />
			</Grid>
			<Grid container alignItems="center" justifyContent="space-between">
				<Grid item>
					<Grid container alignItems="center">
						<Grid container>
							<div className="container-fluid d-flex justify-content-between align-items-center">
								<Typography variant="h1" className={classes.title}>
									{t("timeline.title")}
								</Typography>
								<ReviewDropdown hideCreateReviewButton={true} reviewSelectedCallback={reviewSelectedCallback} />
							</div>
							{selectedReview?.name && (
								<div className={classes.selectedReview}>
									<Chip
										className={classes.reviewChip}
										deleteIcon={<CloseIcon className={classes.reviewChipClose} />}
										label={selectedReview?.name}
										onDelete={handleRemoveReviewContext}
									/>
								</div>
							)}
							<SearchTimeline
								createSearch={submitSearch}
								setInfoPage={setInfoPage}
								border={border}
								setBorder={setBorder}
								setUpdateFiletypes={setUpdateFiletypes}
								setFilterList={setFilterList}
								filterList={filterList}
								setFileTypesRefresh={setFileTypesRefresh}
								docCount={globalStateSearchDocumentList?.count ? globalStateSearchDocumentList.count : docCount || 0}
								toRetainFilters={toRetainFilters}
								searchText={tempSearchText}
								categories={tempCategories}
								setRecordsPerPage={setRecordsPerPage}
								setTimelineSearchCall={setTimelineSearchCall}
								handleReset={handleReset}
								setSelectedGraphDateRange={setSelectedGraphDateRange}
								initilaselectedDateRange={initilaselectedDateRange}
								clearAll={clearAll}
								setClearAll={setClearAll}
								setIsClearClick={setIsClearClick}
								reviewSelectedCallback={reviewSelectedCallback}
								filters={filters}
								mapFiltersToState={mapFiltersToState}
							/>
							{alert && alert.type !== "modal" ? <p className={alert.class}>{alert.msg}</p> : null}
							{/* ////////////////// Filters ////////////////// */}
							{filtersDom}
							{/* {graphLoading ? (
								<div className="col-12 d-flex justify-content-center mt-5 mb-5">
									<div className="d-flex align-items-center">
										<CircularProgress />
									</div>
								</div>
							) : null} */}
						</Grid>
						<Grid container style={{ margin: "30px 0 0 0", background: theme.palette.text.white, padding: "20px" }}>
							{graphData?.length > 1 && (
								<Grid
									item
									xs={12}
									style={{
										paddingBottom: 20,
										justifyContent: "end",
										display: "flex",
									}}
								>
									<Button
										color="secondary"
										className={classes.button}
										startIcon={<TimelineIcon />}
										onClick={() => {
											handleEventForm(true)
											dispatch(setSelectedEvent({}))
										}}
									>
										{t("timeline.addEvent")}
									</Button>
									<Button
										color="secondary"
										className={classes.button}
										startIcon={<EventNoteIcon />}
										onClick={() => {
											dispatch(checkNameAlreadyExistFailed())
											setOpenSaveDialog(true)
										}}
									>
										{t("timeline.saveDataRange")}
									</Button>
									<Button
										color="secondary"
										className={classes.button}
										startIcon={<ExportSVG width={18} height={18} />}
										onClick={() => setOpenExportEvent(true)}
									>
										{t("timeline.export")}
									</Button>
									<ModalPopup
										title={"Export event"}
										open={openExportEvent}
										setOpen={setOpenExportEvent}
										style={{ maxWidth: "1000px", minWidth: "1000px", marginTop: 0 }}
									>
										<ExportEvent callback={setOpenExportEvent} />
									</ModalPopup>
								</Grid>
							)}

							<Grid container className={classes.graphWrapper}>
								<Grid item xs={9} style={{ background: theme.palette.text.white }}>
									<TimelineChart
										refetchList={refetchList}
										//selectedGraphDateRange={selectedGraphDateRange}
										//data={{ tempSearchText, tempCategories, filters }}
									/>
									{/* <TimelineGraph refetchList={refetchList} selectedGraphDateRange={selectedGraphDateRange} /> */}
								</Grid>
								{graphData?.length >= 1 && (
									<Grid
										item
										xs={3}
										style={{
											padding: "0",
											background: theme.palette.grey.D1400,
											border: `solid 1px ${theme.palette.grey.A100}`,
											borderRadius: "5px",
										}}
									>
										<>
											<Tabs
												className={classes.tabs}
												value={panel}
												onChange={handlePanelChange}
												aria-label="Save date range and events"
											>
												<Tab value="one" label={t("event.events")} {...a11yProps("one")} />
												<Tab value="two" label={t("timeline.savedDateRanges")} {...a11yProps("two")} />
											</Tabs>

											<TabPanel value={panel} index="one">
												<Events />
											</TabPanel>
											<TabPanel value={panel} index="two">
												<SavedSearchDateRange
													refetchList={refetchList}
													setSelectedGraphDateRange={setSelectedGraphDateRange}
													initilaselectedDateRange={initilaselectedDateRange}
													handleDateRangeChange={handleDateRangeChange}
													dateRangeHandler={dateRangeHandler}
												/>
											</TabPanel>

											{/**Modal Popup for tabs start*/}
											<ModalPopup
												title={editEvent.id ? t("timeline.createEvent") : t("timeline.editEvent")}
												open={openEventForm}
												setOpen={handleEventForm}
											>
												<CreateEvent callback={handleOpenSaveEventDialog} />
											</ModalPopup>

											<SaveDateRangeDialog
												open={openSaveDialog}
												title={t("timeline.saveDialog.title")}
												onClose={() => {
													setOpenSaveDialog(false)
												}}
												selectedGraphDateRange={selectedGraphDateRange}
											/>
											{/**Modal Popup for tabs end*/}
										</>
									</Grid>
								)}
							</Grid>
						</Grid>
						<Grid container>
							<Grid item xs={12}>
								{globalStateSearchDocumentList?.data?.length > 0 && (
									<ListView
										isEmailType={isEmailFilter}
										isAllDocsViewSelected={isAllDocsViewSelected}
										setPage={setPage}
										page={page}
										recordsPerPage={recordsPerPage}
										setRecordsPerPage={setRecordsPerPage}
										getSkipCount={getSkipCount}
										sortModel={sortModel}
										setSortModel={setSortModel}
										filterDate={filterDate}
										filtersButton={filtersButton}
										filterList={filterList}
										elementsFilter={elementsFilter}
										submitSearch={submitSearch}
										tempSearchText={tempSearchText}
										tempCategories={tempCategories}
										filters={filters}
										toRetainFilterLoading={toRetainFilters}
									/>
								)}
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
			<ModalPopup
				className={classes.fileDeletedModal}
				title={
					<Typography variant="body1" style={{ fontWeight: 500 }}>
						This file has been deleted
					</Typography>
				}
				open={isFileDeleted}
				//setOpen={() => dispatch(setIsFileDeleted(false))}
				showClose={false}
				showDivider={false}
			>
				<FileDeleteModal
					content={t("deleteFile.messageList")}
					btnText={t("deleteFile.buttonTextList")}
					navigate={() => {
						dispatch(setIsFileDeleted(false))
						//debouncedCallback()
						const queryParams = getQueryParams()
						mapDataToState(queryParams)
					}}
				/>
			</ModalPopup>
		</Grid>
	)
}

export default WithDrawer(PageTimeline)
